export const domainConfig = {
  symitarAccountLength: 10,
  cardNumberLength: 16,
  partialSSNLength: 6,
  passwordRules: [
    '8-30 characters',
    'Must have 1 upper and 1 lower case',
    'Must have a number 0-9',
    'Can have special characters as part of password ! # $ % ’ ( ) * + , - ; = ? @ [ ] ^ _ { }',
    'Cannot use space or these special characters as part of password / : " & . < > ` | ~',
    'Username cannot be part of the password',
  ],
};

export const isValidAccountNumberLength = (accountNumber = '') =>
  accountNumber.length > 0 && accountNumber.length <= domainConfig.symitarAccountLength;

export const isValidCardNumberLength = (cardNumber = '') => cardNumber.length === domainConfig.cardNumberLength;

export const isValidSSNLength = (ssn = '') => ssn.length === domainConfig.partialSSNLength;
